import styled from 'styled-components';

export default styled.div`
  flex-grow: 1;
  height: 100%;
  overflow-y: auto;
`;
